import { Spinner } from "@wordpress/components";

export default function LoadingIcon() {
	return (
		<div className="flex items-center justify-center w-full">
			<Spinner
				style={{
					height: "calc(2px * 20)",
					width: "calc(2px * 20)",
				}}
			/>
		</div>
	);
}
